<template>

    <div class="outer-authorized">
        <div class="middle">
            <div class="inner" v-if="error">
                <div class="titles text-cna d-table text-center" style="border-radius: 5%;">
                    <h3 class="uppercase d-table-cell align-middle" style="color: red; font-size: 18px;">
                        <b>Opsss, nos desculpe!<br />Entre em contato com sua escola.</b><br />
                    </h3>
                </div>
                <div class="icon-bottom text-center">
                    <i class="fa fa-6x fa-times" style="font-size: 90px;color: red;"></i>
                </div>
            </div>
            <div class="inner" v-else>
                <div class="titles text-cna d-table text-center">
                    <h3 class="uppercase d-table-cell align-middle">
                        <b>Aguarde,<br />estamos concluindo seu acesso.</b><br />
                    </h3>
                </div>
                <div class="icon-bottom">
                    <i class="fa fa-6x fa-check-circle icon-animated" style="font-size: 90px;color: green;"></i>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

    import Auth from '@/common/auth'
    import Global from '@/common/global'
    import Cache from '@/common/cache'
    import { Api } from '@/common/api'
    import base from '@/common/base.js'

    export default {
        name: 'authorized',
        mixins: [base],
        data() {
            return {
                error: false,
            }
        },
        mounted() {
            Auth.processTokenCallback(() => {

                Auth.getCurrentUser((pessoaCNA, _id) => {

                    if (pessoaCNA) {

                        new Api("pessoa/verificapessoaexistente").post(pessoaCNA).then(async result => {
                            //console.log(result);
                            Cache.add(Auth.loadfinished_key, "finished")
                            Cache.add(Auth.ehCnaStore_key, result.data.cnaStore);
                            //console.log("autoriza", result.data.cnaStore);
                            await new Api("configuracoes").get().then(data => {
                                if (data && data.dataList) {
                                    if (data.dataList.length > 0) {
                                        console.log(data.dataList)
                                        Cache.add(Auth.modalInatividade, ((data.dataList[0].modalInatividade * 60) * 1000));
                                        Cache.add(Auth.encerraSessao, ((data.dataList[0].encerrarSecao * 60) * 1000));
                                    }
                                }
                                else {
                                    Cache.add(Auth.modalInatividade, 600000);
                                    Cache.add(Auth.encerraSessao, 60000);
                                }
                            }, err => {
                                Cache.add(Auth.modalInatividade, 600000);
                                Cache.add(Auth.encerraSessao, 60000);

                            });



                            setTimeout(() => {
                                let _lastlocation = Cache.get(Auth.lastlocation_key);
                                if (_lastlocation) window.location = _lastlocation;
                                else window.location = "/";
                            }, 500);

                        }, err => {
                            this.error = true;
                            this.defaultErrorResult(err, false);
                        })

                    }
                    else {
                        this.error = true;
                        this.defaultErrorResult("Não foi possível encontrar seu usuário > " + _id, false);
                    }

                });
            });
        }
    }
</script>
